import styled from '@emotion/styled'
import Select from 'react-select'

export const Dropdown = styled(Select)`
  min-width: 300px;
  max-width: 300px;

  div[tabindex='-1'] {
    background-color: white !important;
    color: #000 !important;
    cursor: pointer;

    &:hover {
      background-color: ${({ theme }) =>
        `${theme.colors.light.base.hex}`} !important;
    }
  }

  > div {
    border-radius: ${({ theme }) => `${theme.radius}`};
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}`}) {
    min-width: 100%;
  }
`
